var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadBenefit4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 21,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "094_\\u5B58\\u6B3E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M21.719 21L2.62091 21C1.17573 21 0 19.8066 0 18.3398L0 6.2241C0 4.75729 1.17573 3.56396 2.62091 3.56396L21.719 3.56396C23.1641 3.56396 24.3399 4.75729 24.3399 6.2241L24.3399 18.3398C24.3399 19.8066 23.1641 21 21.719 21ZM2.62091 5.16092C2.04347 5.16092 1.57341 5.63801 1.57341 6.2241L1.57341 18.3398C1.57341 18.9259 2.04347 19.403 2.62091 19.403L21.719 19.403C22.2964 19.403 22.7664 18.9259 22.7664 18.3398L22.7664 6.2241C22.7664 5.63801 22.2964 5.16092 21.719 5.16092L2.62091 5.16092Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M25.4526 17.8352L23.8529 17.8352C23.4182 17.8352 23.0662 17.4779 23.0662 17.0367C23.0662 16.5956 23.4182 16.2383 23.8529 16.2383L25.4526 16.2383C25.9896 16.2383 26.4266 15.7947 26.4266 15.2498L26.4266 2.58548C26.4266 2.04051 25.9896 1.59696 25.4526 1.59696L6.20708 1.59696C5.67015 1.59696 5.23314 2.04051 5.23314 2.58548L5.23314 4.01755C5.23314 4.45871 4.88109 4.81603 4.44643 4.81603C4.01178 4.81603 3.65973 4.45871 3.65973 4.01755L3.65973 2.58548C3.65973 1.15979 4.80242 0 6.20708 0L25.4526 0C26.8573 0 28 1.15979 28 2.58548L28 15.2502C28 16.6758 26.8573 17.8356 25.4526 17.8356L25.4526 17.8352Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M12.1699 11.0677C12.0012 11.0677 11.832 11.0126 11.6908 10.9024L9.68118 9.33658C9.3366 9.06789 9.2717 8.56685 9.53603 8.21711C9.80076 7.86738 10.2944 7.8015 10.639 8.06979L12.1695 9.26232L13.7001 8.06979C14.0446 7.80111 14.5387 7.86698 14.803 8.21711C15.0677 8.56685 15.0028 9.06829 14.6579 9.33658L12.6482 10.9024C12.5109 11.0096 12.3424 11.0678 12.1691 11.0677L12.1699 11.0677Z",
    fill: "rgb(141,86,233)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M12.1699 17.0722C11.7353 17.0722 11.3832 16.7149 11.3832 16.2737L11.3832 10.9291C11.3832 10.4879 11.7353 10.1306 12.1699 10.1306C12.6046 10.1306 12.9566 10.4879 12.9566 10.9291L12.9566 16.2737C12.9566 16.7149 12.6046 17.0722 12.1699 17.0722Z",
    fill: "rgb(141,86,233)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M15.0359 12.1504L9.30398 12.1504C8.86932 12.1504 8.51727 11.7931 8.51727 11.3519C8.51727 10.9108 8.86932 10.5535 9.30398 10.5535L15.0359 10.5535C15.4706 10.5535 15.8226 10.9108 15.8226 11.3519C15.8226 11.7931 15.4706 12.1504 15.0359 12.1504ZM15.0359 14.8038L9.30398 14.8038C8.86932 14.8038 8.51727 14.4465 8.51727 14.0053C8.51727 13.5641 8.86932 13.2068 9.30398 13.2068L15.0359 13.2068C15.4706 13.2068 15.8226 13.5641 15.8226 14.0053C15.8226 14.4465 15.4706 14.8038 15.0359 14.8038Z",
    fill: "rgb(141,86,233)",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBenefit4);
export default __webpack_public_path__ + "static/media/download-benefit-4.c7dab73d87ac62fd49e34cd4a1749b39.svg";
export { ForwardRef as ReactComponent };